/**
 * Detects if the app is running on a mobile device based on screen width
 * @param breakpoint - The width breakpoint in pixels (default: 768px)
 * @returns true if screen width is less than or equal to the breakpoint
 */
export const isMobile = (breakpoint: number = 768): boolean => {
  return window.innerWidth <= breakpoint;
};

/**
 * Detects if the app is running on a tablet device based on screen width
 * @returns true if screen width is between 768px and 1024px
 */
export const isTablet = (): boolean => {
  const width = window.innerWidth;
  return width > 768 && width <= 1024;
};

/**
 * Detects if the app is running on a desktop device based on screen width
 * @param breakpoint - The width breakpoint in pixels (default: 1024px)
 * @returns true if screen width is greater than the breakpoint
 */
export const isDesktop = (breakpoint: number = 1024): boolean => {
  return window.innerWidth > breakpoint;
};

/**
 * Gets the current device type based on screen width
 * @returns 'mobile' | 'tablet' | 'desktop'
 */
export const getDeviceType = (): 'mobile' | 'tablet' | 'desktop' => {
  const width = window.innerWidth;
  if (width <= 768) return 'mobile';
  if (width <= 1024) return 'tablet';
  return 'desktop';
};

